var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
export var INSERT_TENANT = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation InsertTenant($slug: String!) {\n        insertTenant(slug: $slug) {\n            id\n            slug\n        }\n    }\n"], ["\n    mutation InsertTenant($slug: String!) {\n        insertTenant(slug: $slug) {\n            id\n            slug\n        }\n    }\n"])));
var templateObject_1;
